var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":_vm.label}},[_c('b-form-select',{attrs:{"name":_vm.name,"options":_vm.listaCargos},model:{value:(_vm.valor),callback:function ($$v) {_vm.valor=$$v},expression:"valor"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }